import React, { useState, useEffect } from "react";
import HeaderComponent from "../../website/HeaderComponent";
import RightSectionEM from "../RightSectionEM/RightSectionEM";
import {
  getAllTeacherForms,
  getTeachersPipelineData,
} from "../../../actions/emActions";
import "../TeacherPipeline/teacherPipeline.scss";
import moment from "moment";
import RecruitmentForm from "./RecruitmentForm";
import { teacherStatusUpdate } from "../../../actions/tutorFeedActions";
import { Spinner } from "reactstrap";

const RecruitmentProcess = (props) => {
  const [teachersData, setteachersData] = useState([]);
  const [classesName, setclassesName] = useState([]);
  const [page, setpage] = useState("1");
  const [limit, setlimit] = useState("20");
  const [loader, setloader] = useState(false);
  const [search, setSearch] = useState("");
  const [status, setstatus] = useState("");

  const getData = () => {
    getAllTeacherForms(limit, page, search, status)
      .then((res) => {
        setteachersData(res?.data);
        console.log(res?.data);
        setloader(false);
      })
      .catch((err) => {
        console.log(err);
        debugger;
      });
  };

  useEffect(() => {
    const timeoutId = setTimeout(() => {
      getData();
    }, 2000);

    return () => clearTimeout(timeoutId);
  }, [search, status]);
  useEffect(() => {
    setloader(true);
    getData();
  }, [limit]);

  const changeStatusFunc = (value, id) => {
    debugger;
    teacherStatusUpdate(parseInt(value), id).then((resp) => {
      debugger;
      getData();
    });
  };

  return (
    <div>
      <HeaderComponent />
      <div style={{ padding: "2vh 0" }}>
        <div className="container-fluid">
          <div className="row">
            <div className="col-md-3">
              <RightSectionEM />
            </div>

            <div className="col-md-9 teacherManagement">
              <h5 className="mb-3">Teacher Recruitment:</h5>

              <div className="filterSection">
                <h5>
                  <i className="fa fa-filter"></i> Filter By:
                </h5>
                <div className="row">
                  <div className="col-md-3">
                    <div>
                      <label className="filterName">Search:</label>
                      <br />
                      <input
                        onChange={(e) => setSearch(e.target.value)}
                        placeholder=""
                        className="searchField"
                        type="text"
                      />
                    </div>
                  </div>

                  <div className="col-md-3">
                    <div>
                      <label className="filterName">Status:</label>
                      <br />
                      <select
                        className="selectField"
                        onChange={(e) => setstatus(e.target.value)}
                      >
                        <option value="">Select Status</option>
                        <option value={2}>Seen</option>
                        <option value={3}>Short Listed</option>
                        <option value={4}>Rejected</option>
                        <option value={5}>Interview</option>
                        <option value={6}>Hired</option>
                        <option value={7}>Hide</option>
                        {/* <option value={11}>Imported</option> */}
                      </select>
                    </div>
                  </div>
                </div>
              </div>
              <div id="accordionForTeacherManagement" class="myaccordion">
                <div id="body" className="table-responsive">
                  <table class="table table-hover table-striped">
                    <thead className="teacherManagementHeader">
                      <tr className="d-flex">
                        <th className="col-sm-1">#</th>
                        <th className="col-sm-2">Teacher Name</th>
                        <th className="col-sm-3">Contact Information</th>
                        <th className="col-sm-2">Sign up at</th>
                        <th className="col-sm-2">Status</th>
                        <th className="col-sm-2">Action</th>
                      </tr>
                    </thead>

                    <tbody>
                      {teachersData &&
                        teachersData.map((item, index) => (
                          <React.Fragment key={index}>
                            <tr key={index} className="collapsed d-flex">
                              <td
                                data-toggle="collapse"
                                data-target={`#One${index}`}
                                aria-expanded="true"
                                aria-controls="collapseOne"
                                className="col-sm-1"
                              >
                                {index + 1}.
                              </td>
                              <td
                                data-toggle="collapse"
                                data-target={`#One${index}`}
                                aria-expanded="true"
                                aria-controls="collapseOne"
                                className="col-sm-2 col-2"
                              >
                                <label> {item?.teacher?.user_name}</label>{" "}
                                <br />{" "}
                              </td>

                              <td
                                data-toggle="collapse"
                                data-target={`#One${index}`}
                                aria-expanded="true"
                                aria-controls="collapseOne"
                                className="col-sm-3"
                              >
                                <label className="mb-0">
                                  {item?.teacher?.user_email}
                                </label>{" "}
                                <br />{" "}
                                <label
                                  style={{
                                    color: "#42b72a",
                                    cursor: "pointer",
                                  }}
                                  className="font-weight-bold phoneNumberSize d-flex"
                                >
                                  <i className="fas fa-mobile-alt mr-1 mt-1"></i>
                                  <a
                                    className=""
                                    style={{
                                      color: "#42b72a",
                                      cursor: "pointer",
                                    }}
                                    href={`tel:+${item?.teacher?.lm_candidate_profile?.[0]?.phone}`}
                                  >
                                    +
                                    {
                                      item?.teacher?.lm_candidate_profile?.[0]
                                        ?.phone
                                    }
                                  </a>
                                </label>
                                {/* <label className="text-muted">
                                  +{item?.lm_candidate_profile?.[0]?.phone}
                                </label> */}
                              </td>
                              <td
                                data-toggle="collapse"
                                data-target={`#One${index}`}
                                aria-expanded="true"
                                aria-controls="collapseOne"
                                className="col-sm-2"
                              >
                                <label className="mb-0">
                                  {moment(item?.teacher?.ts).format("D MMM YY")}
                                </label>{" "}
                                <br />{" "}
                                <span style={{ fontSize: 12 }}>
                                  {" "}
                                  {moment(item?.teacher?.ts).format(
                                    "ddd hh:mm A"
                                  )}{" "}
                                </span>
                              </td>
                              <td
                                data-toggle="collapse"
                                data-target={`#One${index}`}
                                aria-expanded="true"
                                aria-controls="collapseOne"
                                className="col-sm-2"
                              >
                                <label className="mb-0">
                                  {item?.status === 0 ? (
                                    <label className="text-primary font-weight-bold">
                                      Signed Up
                                    </label>
                                  ) : item?.status === 1 ? (
                                    <label className="text-success font-weight-bold">
                                      Form Submitted
                                    </label>
                                  ) : item?.status === 2 ? (
                                    <label className="text-secondary font-weight-bold">
                                      Seen
                                    </label>
                                  ) : item?.status === 3 ? (
                                    <label className="text-success font-weight-bold">
                                      Short Listed
                                    </label>
                                  ) : item?.status === 4 ? (
                                    <label className="text-danger font-weight-bold">
                                      Rejected{" "}
                                      <i className="fa fa-frown-o text-danger" />
                                    </label>
                                  ) : item?.status === 5 ? (
                                    <label className="text-success font-weight-bold">
                                      Interview{" "}
                                      <i className="fa fa-star-half text-success" />
                                    </label>
                                  ) : item?.status === 6 ? (
                                    <label className="text-success font-weight-bold">
                                      Hired{" "}
                                      <i className="fa fa-star text-success" />
                                    </label>
                                  ) : null}
                                </label>
                              </td>
                              <td className="col-sm-2 col-2">
                                <select
                                  className="form-control form-control-sm"
                                  value={item?.status}
                                  onChange={(e) =>
                                    changeStatusFunc(e.target.value, item?.id)
                                  }
                                >
                                  <option value="">Perform Action</option>
                                  <option value={2}>Seen</option>
                                  <option value={3}>Short Listed</option>
                                  <option value={4}>Rejected</option>
                                  <option value={5}>Interview</option>
                                  <option value={6}>Hired</option>
                                  <option value={7}>Hide</option>
                                  {/* <option value={11}>Imported</option> */}
                                </select>
                              </td>
                            </tr>
                            {item?.status !== 0 && (
                              <div
                                id={`One${index}`}
                                className="collapse accordionBox"
                                aria-labelledby="headingOne"
                                data-parent="#accordionForTeacherManagement"
                              >
                                <RecruitmentForm
                                  teacherForm={item?.teacher_form}
                                />
                              </div>
                            )}
                          </React.Fragment>
                        ))}
                    </tbody>
                  </table>
                </div>
              </div>
              <div className="text-center mb-4 mt-2">
                <button
                  className="btn btn-warning btn-sm"
                  onClick={() => {
                    setlimit(+limit + 20);
                  }}
                >
                  {loader ? (
                    <Spinner size="sm" />
                  ) : (
                    <span>
                      Load More <i className="fa fa-chevron-down"></i>
                    </span>
                  )}
                </button>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default RecruitmentProcess;
